export default "__VITE_ASSET__BPwpbTNr__"